import { render, staticRenderFns } from "./MyStudents.vue?vue&type=template&id=d1933674&scoped=true"
import script from "./MyStudents.vue?vue&type=script&lang=js"
export * from "./MyStudents.vue?vue&type=script&lang=js"
import style0 from "./MyStudents.vue?vue&type=style&index=0&id=d1933674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1933674",
  null
  
)

export default component.exports